import { directDebitTypes } from '@/configuration/pages/ConfigurationPage/constants'

export const titleText = {
  default: {
    [directDebitTypes.SEPA]: 'Domiciliación de adeudo directo SEPA',
    [directDebitTypes.BACS]: 'Domiciliación de adeudo directo BACS',
  },
  bank_transfer: {
    [directDebitTypes.SEPA]:
      'Domiciliación de adeudo directo SEPA para reembolsos instantáneos mediante transferencia bancaria',
    [directDebitTypes.BACS]:
      'Domiciliación de adeudo directo BACS para reembolsos instantáneos mediante transferencia bancaria',
  },
}

export const descriptionText = {
  default:
    'Firme este mandato para autorizar a Reveni a cargar en su cuenta los pagos correspondientes a su operativa en la plataforma, en su nombre. Usted tiene ciertos derechos en virtud de la legislación aplicable.',
  bank_transfer:
    'Firme este mandato para autorizar a Reveni a cargar en su cuenta todos los pagos correspondientes a reembolsos instantáneos emitidos mediante transferencia bancaria por Reveni, en su nombre. Usted tiene ciertos derechos en virtud de la legislación aplicable.',
}
